<template>
  <q-card>
    <q-form @submit.prevent="addLabel">
      <q-card-section>
        <div class="text-h6">Ярлыки проекта</div>
      </q-card-section>
      <q-card-section v-if="!isFetching">
        <q-chip  v-for="label in labels" :style="{background: label.color}" removable @remove="deleteLabel(label.id)" text-color="white">
          {{ label.name }}
          <q-tooltip>
            {{ label.description }}
          </q-tooltip>
        </q-chip>
      </q-card-section>
      <q-card-section v-else>
        <q-skeleton type="QChip"/>
      </q-card-section>


      <q-card-section class="q-pt-none">
        <q-input dense v-model.trim="newLabel.name" label="Имя ярлыка" :rules="[requiredRule]"/>
        <q-input
            v-model="newLabel.color"
           :rules="['hexColor']"
        >
          <template v-slot:append>
            <q-icon name="colorize" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-color v-model="newLabel.color" />
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <q-input dense v-model.trim="newLabel.description" type="textarea" label="Описание"/>
      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn no-caps flat label="Добавить"  type="submit"/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script setup lang="ts">
import {useAddProjectLabel, useDeleteProjectLabel, useProjectLabels} from "../composables/project";
import {useRoute} from "vue-router";
import {computed, reactive} from "vue";
import {NewLabel} from "../models/task";
import {requiredRule} from "../util/rules";


const route = useRoute()
const projectId = computed(() => Number(route.params.projectId))

const {data: labels, execute: fetchProjectLabels, isFetching} = useProjectLabels(projectId)


const newLabel: NewLabel = reactive({
  name: "",
  color: "#000000",
  description: ""
})
const {execute} = useAddProjectLabel(projectId, newLabel)

async function deleteLabel(id: number) {
  await useDeleteProjectLabel(projectId, id)

  await fetchProjectLabels()
}

async function addLabel() {
  await execute(true)
  await fetchProjectLabels()
}
</script>

<style scoped>

</style>